import { render, staticRenderFns } from "./test1-4.vue?vue&type=template&id=67dd93cf&scoped=true"
import script from "./test1-4.vue?vue&type=script&lang=js"
export * from "./test1-4.vue?vue&type=script&lang=js"
import style0 from "./test1-4.vue?vue&type=style&index=0&id=67dd93cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd93cf",
  null
  
)

export default component.exports